// extracted by mini-css-extract-plugin
export default {"selector":"VBNWaySwitch_selector__TnryN"};